import Udesk from 'Udesk';
import React, { useRef, useState } from 'react';
import Page from 'Component/common/udesk-qa-page-layout';
import ViewTabs from './components/ViewTabs';
import QualityTasksTypeTabs from './components/QualityTasksTypeTabs';
import QaResultView from './components/QaResultView';
import CaseLibView from './components/CaseLibView';
import './style.scss';

const SDK: React.FC<any> = (props) => {
    const [loading, setLoading] = useState<boolean>(true);

    const [viewTabKey, setViewTabKey] = useState<string>('QaResultView');

    const onViewTabChange = (activeKey: string) => {
        setViewTabKey(activeKey);
    };

    const [tasksType, setTasksType] = useState<number>();

    const QaResultViewRef = useRef<any>(null);
    const CaseLibViewRef = useRef<any>(null);

    const onTasksTypeChange = (activeKey) => {
        QaResultViewRef.current?.onTasksTypeChange(activeKey * 1);
        CaseLibViewRef.current?.onTasksTypeChange(activeKey * 1);
    };

    const [qualityTasksTypes, setQualityTasksTypes] = useState<any[]>([]);

    return (
        <Page
            style={tasksType === null ? undefined : { paddingBottom: 0 }}
            pageBodyClassName="appeal-checking-task-page-new"
            title={<ViewTabs activeTabKey={viewTabKey} onChange={onViewTabChange} />}
            backGroundGhost={true}
            footer={
                <QualityTasksTypeTabs
                    activeTabKey={tasksType}
                    onChange={onTasksTypeChange}
                    qualityTasksTypes={qualityTasksTypes}
                />
            }
            loading={loading && !tasksType}
        >
            {viewTabKey === 'QaResultView' ? (
                <QaResultView
                    {...props}
                    forwardRef={QaResultViewRef}
                    tasksType={tasksType}
                    setTasksType={setTasksType}
                    setQualityTasksTypes={setQualityTasksTypes}
                    loading={loading}
                    setLoading={setLoading}
                />
            ) : viewTabKey === 'CaseLibView' ? (
                <CaseLibView
                    {...props}
                    forwardRef={CaseLibViewRef}
                    tasksType={tasksType}
                    setTasksType={setTasksType}
                    setQualityTasksTypes={setQualityTasksTypes}
                    loading={loading}
                    setLoading={setLoading}
                />
            ) : null}
        </Page>
    );
};

class Component extends React.Component {
    render() {
        return <SDK {...this.props} />;
    }
}

export default Udesk.react.udeskify(Component);
